export default "__VITE_ASSET__GOOb_wv2__"